import BaseStore, { LOADING, LOADED } from 'stores/BaseStore';
import appStore from 'stores/app';
import config from 'config';
import HttpClient from 'utils/httpclient';
import { nest } from 'd3-collection'
import Moment from 'moment-timezone';

import publisherStore from 'modules/offer/stores/publisher'

export default new class OptoutStore extends BaseStore {
  summary = {
    readyState: LOADED,
    data: null,
    isLoading: () => {
      return this.readyState === LOADING
    }
  }

  constructor() {
    super('ccpa/suppress', 'ccpa/suppress', { site_model: true });
  }

  async getSumary({ group, filters: { searchStartDate, searchEndDate, siteId } }) {
    const { site, timezone } = appStore
    group = group.map(({ key }) => key)
    const params = {
      timezone,
      groupping: group,
      siteId: site.id,
      search: {
        endDate: Moment.tz(searchEndDate, timezone).format(),
        startDate: Moment.tz(searchStartDate, timezone).format(),
        siteId
      }
    }
    this.summary.readyState = LOADING;

    this.publishers = await publisherStore.all().then(({ data }) => data)

    return HttpClient.get(`${config.api}/ccpa/summary`, { params })
      .then(response => {
        if (response.data)
          return this.summary.data = nest().key(d => d[group[0]]).entries(response.data);
      })
      .finally(() => this.summary.readyState = LOADED);
  }

  get siteId() { return appStore.site.id }

  getPublisher(pid) {
    return this.publishers && this.publishers.find(({ id }) => id == pid) || {}
  }

  getSiteName(stid) {
    return (appStore.sites && appStore.sites.find(({ id }) => id == stid) || {}).name
  }

  date(value) {
    return Moment.tz(Moment(value).utc().format('YYYY-MM-DD'), appStore.timezone)
  }
}